import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function Protected({ children, admin = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="grid min-h-screen place-items-center bg-bg">
        <div className="font-mono text-sm text-muted" data-testid="auth-checking">
          Checking your session…
        </div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}
